// extracted by mini-css-extract-plugin
export default {"root":"SupportEmailCard_root-KOl","content":"SupportEmailCard_content-vm4","message":"SupportEmailCard_message-g3W","copied":"SupportEmailCard_copied-yY_"};